import { createContext, useContext } from 'react';
import { MapData } from '../Types/types';

export type MapDataState = [MapData, React.Dispatch<React.SetStateAction<MapData>>];
export const MapDataContext = createContext<MapDataState>([undefined, undefined]);
export const useMapData = (): MapDataState => {
    return useContext<MapDataState>(MapDataContext);
};
